import styled from 'styled-components'
import { Card, Table } from 'antd'

export const DisplayCard = styled(Card)`
  & {
    border-radius: 8px;
    margin-bottom: 15px;

    .antd-card-head-title {
      font-size: 18px;
    }
  }
`
export const DisplayCardTitleWrapper = styled.div`
  font-size: 18px;
  &.blue {
    color: blue;
  }
  &.green {
    color: green;
  }
`
export const DisplayTable = styled(Table)`
  && {
    th.ant-table-cell {
      background-color: #ffffff;
    }

    tr:nth-child(odd) {
      td {
        background-color: #f5f7fb;
      }
    }
  }
`

export const InformationWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`

export const Col = styled.div`
  display: flex;
  flex-direction: column;
  width: 30%;
`

export const Row = styled.div`
  display: flex;
  justify-content: space-between;

  span:first-of-type {
    font-weight: bold;
  }
`

export const Link = styled.a`
  font-size: 12px;
  font-weight: bold;
  margin-top: 5px;
  padding: 7px 10px 7px 10px;
  border-radius: 5px;
  border: 1px solid #f0f0f0;
  font-style: bold;
`

export const FormalityListStatus = styled.div`
  &.success {
    color: green;
  }
  &.error {
    color: red;
  }
  &.pending {
    color: gray;
  }
`
